import React, { useRef, useEffect, useCallback, forwardRef } from "react";
import { cn } from "@/lib/utils";

const AutoGrowTextarea = forwardRef(
  ({ value, onChange, onSubmit, maxRows = 5, className, disabled, ...props }, ref) => {
    const internalRef = useRef(null);
    const textareaRef = ref || internalRef;

    const adjustHeight = useCallback(() => {
      const el = typeof textareaRef === "function" ? null : textareaRef.current;
      if (!el) return;

      el.style.height = "auto";
      const lineHeight = parseInt(getComputedStyle(el).lineHeight) || 20;
      const maxHeight = lineHeight * maxRows;
      el.style.height = `${Math.min(el.scrollHeight, maxHeight)}px`;
    }, [maxRows, textareaRef]);

    useEffect(() => {
      adjustHeight();
    }, [value, adjustHeight]);

    const handleKeyDown = (e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        onSubmit?.();
      }
    };

    return (
      <textarea
        ref={textareaRef}
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        rows={1}
        disabled={disabled}
        className={cn(
          "flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 resize-none leading-5",
          className
        )}
        {...props}
      />
    );
  }
);

AutoGrowTextarea.displayName = "AutoGrowTextarea";

export default AutoGrowTextarea;
